import { create } from "zustand"

type LocationStore = {
	pendingStateFieldId: string | null
	pendingState: string | null
	setPendingStateFieldId: (fieldId: string | null) => void
	setPendingState: (state: string | null) => void
}

export const useLocationStore = create<LocationStore>()(set => ({
	pendingStateFieldId: null,
	setPendingStateFieldId: fieldId =>
		set(() => ({ pendingStateFieldId: fieldId })),
	pendingState: null,
	setPendingState: state => set(() => ({ pendingState: state })),
}))
